<template>
  <div class="flex flex-column align-center">
    <div class="flex head">
      <div class="icon"></div>
    </div>
    <!-- <div class="tip">注册成功！</div> -->
    <div class="btn" @click="down">点击下载APP</div>
  </div>
</template>

<script>
import '../assets/css/flexbox.css';
import common from '../assets/js/common';
export default ({
  methods: {
    down() {
      if (common.isAndroid()) {
        window.location.href = "https://www.pgyer.com/I9in";
      } else {
        window.location.href = "https://apps.apple.com/app/%E5%8D%83%E6%9D%A5%E8%81%9A%E6%98%93%E6%B5%8B/id1601835152";
      }
    }
  }
})
</script>
<style lang="less" scoped>
.icon {
  background-image: url('../assets/imgs/logo-150.png');
  height: 2rem;
  width: 2rem;
  background-repeat: no-repeat;
  background-size: contain;
  margin-top: 1.71rem;
}
.head {
  width: 100%;
  justify-content: center;
}
.tip {
  height: 0.56rem;
  font-size: 0.4rem;
  font-weight: bold;
  line-height: 0.52rem;
  color: #432F12;
  margin-top: 0.4rem;
}
.btn {
  width: 6.93rem;
  height: 1.31rem;
  background: #FAAB32;
  border-radius: 1.17rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 0.8rem;
  font-weight: bold;
  line-height: 0.4rem;
  font-size: 0.43rem;
  color: #FFFFFF;
}
</style>
